import {downloadCSVFiles} from '@/helpers/shadcn/utils'
import {getInventoryFileUploadErrors, getInventoryUploadHistory} from '@/services/ProductsService/Fulfillment/inventory'
import {DEFAULT_TABLE_PAGE_SIZE} from '@/utils/constants/commonConstants'
import {useQuery} from '@tanstack/react-query'
import {useMemo, useState} from 'react'

export const INVENTORY_UPLOAD_HISTORY_KEY = 'INVENTORY_UPLOAD_HISTORY'

const useUploadHistory = (type, enabled = false) => {
  const [uploadHistoryPageIndex, setUploadHistoryPageIndex] = useState(0)

  const uploadHistoryQueryParams = useMemo(() => {
    const params = new URLSearchParams()
    params.append('sort', 'createdDateTime,desc')
    params.append('page', uploadHistoryPageIndex)
    params.append('pageSize', DEFAULT_TABLE_PAGE_SIZE)
    return params.toString()
  }, [uploadHistoryPageIndex])

  const uploadHistoryResult = useQuery({
    queryKey: [INVENTORY_UPLOAD_HISTORY_KEY, type, uploadHistoryQueryParams],
    queryFn: () => getInventoryUploadHistory(type, uploadHistoryQueryParams),
    enabled: !!enabled,
  })

  const uploadHistory = uploadHistoryResult?.data

  const getErrorTemplateFilename = () => {
    const date = new Date()
    const timestamp = date.toISOString().replace(/[-:]/g, '').replace('T', '_').split('.')[0]
    return `Upload_Error_Template_${timestamp}`
  }

  const downloadUploadError = async parentId => {
    const response = await getInventoryFileUploadErrors(parentId, 'text/csv')
    await downloadCSVFiles(response, getErrorTemplateFilename())
  }

  const fetchUploadErrors = async parentId => {
    const res = await getInventoryFileUploadErrors(parentId)

    const productRows = res?.rows || res?.data || []

    const flattened = productRows.map(row => {
      const pid = row?.productId ?? '-'
      const wid = row?.locationId ?? row?.warehouseId ?? '-'
      const errorsArr = Array.isArray(row?.errors) ? row.errors : []

      // If there are no error details, return placeholders
      if (errorsArr.length === 0) {
        return {
          productId: pid,
          warehouseId: wid,
          errorCol: '-',
          errorMsg: '-',
        }
      }

      // Build a combined error message string: "<errorCol> <errorMsg>" joined by comma
      const combinedErrorMsg = errorsArr
        .map(errItem => {
          const errorCol = errItem?.errorCol ?? '-'
          const errorMsg = errItem?.errorMsg ?? '-'
          return `${errorCol} ${errorMsg}`.trim()
        })
        .join(' , ')

      return {
        productId: pid,
        warehouseId: wid,
        errorCol: '',
        errorMsg: combinedErrorMsg,
      }
    })

    return flattened
  }

  return {
    onUploadHistoryPageIndexChange: setUploadHistoryPageIndex,
    uploadHistoryData: uploadHistory || [],
    downloadUploadError,
    fetchUploadErrors,
  }
}

export default useUploadHistory
